import React, { useState, useEffect } from 'react';
import { courseColor, educationData, myBG } from '../helper/constants';
import Subject from '../helper/Subject';

const Education = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize(); // Check initial width
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const containerStyles = isMobile
    ? styles.containerMobile
    : styles.containerTable;

  return (
    <section id='education' style={styles.heading}>
      <h2>Education</h2>

      {educationData.map((educationItem) => (
        <div key={educationItem.id} style={containerStyles}>
          <div style={styles.logoColumn}>
            <img src={educationItem.logo} alt='Logo' style={styles.logoImage} />
            <br />
            <b>{educationItem.institution}</b>
            <br />
            <br />
            <i>{educationItem.college}</i>
          </div>
          <div style={styles.degreeColumn}>
            🎓
            <br />
            <b>{educationItem.degree}</b> <br />
            <br />
            <b>{educationItem.field}</b>
          </div>
          {isMobile ? (
            <>
              <div style={styles.row}>
                <div style={styles.coursesColumnMobile}>
                  <Subject educationType={educationItem.educationType} />
                </div>
                <div style={styles.durationColumnMobile}>
                  {educationItem.duration}
                </div>
              </div>
            </>
          ) : (
            <>
              <div style={styles.coursesColumn}>
                <Subject educationType={educationItem.educationType} />
              </div>
              <div style={styles.durationColumn}>{educationItem.duration}</div>
            </>
          )}
        </div>
      ))}
      <br />
      <div style={styles.notationText}>
        * click a course to see skills & projects
      </div>
    </section>
  );
};

const styles = {
  heading: {
    marginTop: '10px',
    marginLeft: '5px',
    marginBottom: '10px',
    marginRight: '5px',
    // border: '1px solid red',
    padding: '20px', // Add some padding to create space around the content
    // background: 'rgba(255, 255, 255, 0.2)', // Use an rgba color for the background with reduced opacity
    background: myBG,
    backdropFilter: 'blur(10px)', // Add a blur effect to create the glass panel effect
    borderRadius: '10px', // Add rounded corners for a better look
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', // Add a subtle shadow for depth
  },
  containerMobile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '10% 10% 5%',
    borderBottom: '1px solid black',
  },
  // container: {
  //   // display: 'flex',
  //   justifyContent: 'center',
  //   margin: '10% 10%',
  // },
  // entry: {
  //   marginBottom: '20px',
  //   border: '1px solid red',
  // },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    // marginBottom: '20px',
    // border: '1px solid red',
  },
  coursesColumnMobile: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '0',
    flexGrow: '1',
    marginRight: '5px',
    // border: '1px solid blue',
  },
  durationColumnMobile: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '0',
    flexGrow: '1',
    marginRight: '5px',
    // border: '1px solid red',
  },
  columnImage: {
    flex: '20%',
    textAlign: 'center',
  },
  columnName: {
    flex: '20%',
    textAlign: 'center',
  },
  columnDegree: {
    flex: '80%',
  },
  columnCollegeName: {
    flex: '40%',
  },
  columnYear: {
    flex: '40%',
  },
  columnCourses: {
    flex: '100%',
  },
  containerTable: {
    display: 'grid',
    // gridTemplateColumns: '17.5% 15% 55% 12.5%',
    gridTemplateColumns: '20% 17% 55% 8%',
    // gridGap: '20px',
    maxWidth: '1200px',
    margin: '0 auto',
    // marginBottom: '5px',
    textAlign: 'center',
    justifyContent: 'center', // Center horizontally
    alignItems: 'center', // Center vertically
    // border: '1px solid green',
    marginTop: '10px',
    paddingBottom: '5px',
    borderBottom: '1px solid black',
  },
  logoColumn: {
    marginRight: '5px',
    marginBottom: '5px',
    // border: '1px solid red',
  },
  degreeColumn: {
    marginRight: '5px',
    marginBottom: '5px',
    // border: '1px solid red',
  },
  coursesColumn: {
    // display: 'flex',
    // flexDirection: 'column',
    // gap: '10px',
    marginRight: '5px',
    marginBottom: '5px',
    // border: '1px solid red',
  },
  durationColumn: {
    marginRight: '5px',
    marginBottom: '5px',
    // border: '1px solid red',
  },
  logoImage: {
    width: '80px',
    height: '80px',
  },
  bold: {
    fontWeight: 'bold',
  },
  italic: {
    fontStyle: 'italic',
  },
  notationText: {
    color: courseColor,
    // color: 'hsl(210, 100%, 70%)',
    // color: 'hsl(lightblue, 100%, 90%)',
    fontStyle: 'italic',
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'right',
  },
  divider: {
    borderTop: '1px solid black',
    margin: '10px',
  },
};

export default Education;
